module.exports = __webpack_public_path__ + "static/media/img-talent-profile-cards.a8062ebd.png";